import ApiService from './api.service'

const PlayerService = {
  index (search = '', page = 1) {
    return ApiService.get(`api/v1/admin/players?search=${search}&page=${page}`)
  },

  exists (firstName, lastName, birthYear) {
    return ApiService.get('api/v1/admin/players/exists', {
      params: {
        firstName: firstName,
        lastName: lastName,
        birthYear: birthYear
      }
    })
  },

  show (uuid) {
    return ApiService.get('api/v1/admin/players/' + uuid)
  },

  update (uuid, data) {
    return ApiService.put('api/v1/admin/players/' + uuid, data)
  },

  merge (data) {
    return ApiService.postWithoutLoading('api/v1/admin/players/merge', data)
  },

  store (data) {
    return ApiService.post('api/v1/admin/players', data)
  },

  duplicates (params) {
    return ApiService.get('api/v1/admin/players/duplicates', { params })
  },

  ignoreDuplicate (data) {
    return ApiService.post('api/v1/admin/players/duplicates/ignore', data)
  },

  updateTags (uuid, data) {
    return ApiService.putWithoutLoading('api/v1/admin/players/' + uuid + '/tags', data)
  }
}

export default PlayerService
